import React from 'react';
import { Chip } from '@mui/material';
import { CompanyUserChipsProps } from './types';

const CompanyUserChips = ({ users, onDelete }: CompanyUserChipsProps) => (
  <div>
    {users?.map(user => (
      <Chip
        key={user.email}
        label={user.email}
        onDelete={onDelete ? () => onDelete(user) : undefined}
        style={{ margin: '0.25rem', fontSize: '0.7rem' }}
      />
    ))}
  </div>
);

export default CompanyUserChips;
